import { render } from "./view_request.vue?vue&type=template&id=db6b35a4"
import script from "./view_request.vue?vue&type=script&lang=js"
export * from "./view_request.vue?vue&type=script&lang=js"

import "./view_request.vue?vue&type=style&index=0&id=db6b35a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__